import React, { useEffect, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useGlobalVariablesContext } from '../../context/GlobalVariablesContext';
import { useToolsContext } from '../../context/ToolsContext';
import MapContext from '../Map/MapContext';
import Tool from '../Tool/Tool';
import { handleMapClickGeoJSON } from '../AttributeQuery/_handleMapClickGeoJSON';
import { handleMapClickWMS } from '../AttributeQuery/_handleMapClickWMS';

/**
 * Herramienta de consultas que funciona como AttributeQuery pero muestra resultados en RightSidebar
 */
const QueriesTool = () => {
  const { t } = useTranslation();
  const { map } = useContext(MapContext);
  const { config, visibleOverlayLayers, setQueriesResults, setSidebarOpenRight, setActiveTabContentSidebarRight } = useGlobalVariablesContext();
  const { toolStates } = useToolsContext();

  const [features, setFeatures] = useState([]);

  // Procesar los resultados cuando cambien
  useEffect(() => {
    if (features && features.length > 0) {
      // Organizar features por categoría
      const featuresByCategory = {};
      features.forEach((item) => {
        Object.keys(item).forEach((key) => {
          if (!featuresByCategory[key]) {
            featuresByCategory[key] = [];
          }
          featuresByCategory[key].push(...item[key]);
        });
      });
      
      // Pasar los resultados al contexto global para que los use el RightSidebar
      setQueriesResults(featuresByCategory);
      
      // Abrir el RightSidebar y cambiar a la pestaña de consultas
      setSidebarOpenRight(true);
      setActiveTabContentSidebarRight('consultas');
    }
  }, [features, setQueriesResults, setSidebarOpenRight, setActiveTabContentSidebarRight]);

  useEffect(() => {
    if (!map || !toolStates?.queries) return;

    const mapElement = map.getTargetElement();

    const handleClick = (event) => {
      setFeatures([]); // Limpiar resultados previos
      
      // Usar el mismo patrón que AttributeQuery original
      handleMapClickGeoJSON(event, map, setFeatures);
      handleMapClickWMS(event, map, visibleOverlayLayers, setFeatures, config);
    };

    if (toolStates.queries.active) {
      map.on('singleclick', handleClick);
      if (mapElement) mapElement.style.cursor = 'help';
    } else {
      map.un('singleclick', handleClick);
      if (mapElement) mapElement.style.cursor = '';
    }

    return () => {
      if (map) map.un('singleclick', handleClick);
      if (mapElement) mapElement.style.cursor = '';
    };
  }, [toolStates, map, visibleOverlayLayers, config, setQueriesResults]);

  return (
    <Tool
      id="queries"
      type="toggleable"
      icon="bi bi-info-circle-fill"
      label={t('Consultas de Atributos no terminado')}
    />
  );
};

export default QueriesTool;
